module.exports = __webpack_public_path__ + "static/media/App_Store_Badge_US-UK_RGB_blk.2928664f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/App_Store_Badge_US-UK_RGB_blk.svg
// module id = 1244
// module chunks = 0